import { useState } from "react";
import { useParams } from "react-router-dom";
import HrmLeaveRequestTableDetail from "../../components/hrm/HrmLeaveRequestTable";
import { ILeaveRequestQuery } from "../../models/Hrm";
import { useGetLeaveByEmployeeId } from "../../query/HrmQuery";
import NotFound from "../NotFound/NotFound";

export const HrmLeaveEmployee = () => {
  const { alias } = useParams<{ alias: string }>();
  const [filter, setFilter] = useState<ILeaveRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetLeaveByEmployeeId(alias!, filter);
  if (!alias) return <NotFound />;
  return (
    <HrmLeaveRequestTableDetail
      data={data!}
      isLoading={isLoading}
      filter={filter}
      setFilter={setFilter}
      isHasAvatars={false}
    />
  );
};
